import React, { memo } from 'react';
import VariantFormErrorNotification from './variant-form-error-notification';
import './form-error-notification.module.scss';

type Props = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  errorMessage?: any;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  onClose: any;
};

const FormErrorNotification = memo<Props>((props: Props) => {
  const { errorMessage, onClose } = props;

  return errorMessage ? (
    <VariantFormErrorNotification
      errorMessage={errorMessage}
      onClose={onClose}
    />
  ) : null;
});

export { FormErrorNotification };
export default FormErrorNotification;
